import request from '@/utils/request'

export function getMsgList (data) {
  return request({
    url: 'message/index',
    method: 'get',
    params: data
  })
}
export function getMsgDetail (data) {
  return request({
    url: 'message/detail',
    method: 'get',
    params: data
  })
}
export function getMsgType (data) {
  return request({
    url: 'message/type',
    method: 'get',
    params: data
  })
}
